"use strict";
// 仅用于登录/鉴权相关接口（user/getUserInfo 等）；业务接口请走 digitwai-ai /api/training/*
const httpPrefix = 'https://api-digitwai.shanhaiyh.com/shiant-api-c/service/';
function captureTokenFromUrl() {
    if (window.location.href.indexOf('token=') === -1) return;
    var href = window.location.href;
    var token = null;
    try {
        token = new URL(href).searchParams.get('token');
    } catch (e) {}
    // 兼容 ?id=xxx?token=yyy 等 SSO 异常回跳（searchParams 取不到 token）
    if (!token) {
        var m = href.match(/(?:^|[?&])token=([^&#]+)/i);
        if (m) try {
            token = decodeURIComponent(m[1]);
        } catch (e2) {
            token = m[1];
        }
    }
    if (!token) return;
    localStorage.setItem('token', token);
    localStorage.setItem('jsessionid', token);
    var clean = href.replace(/([?&])token=[^&#]*/gi, '').replace(/\?&/g, '?').replace(/[?&]$/, '');
    try {
        window.history.replaceState({}, '', clean);
    } catch (e3) {}
}
captureTokenFromUrl();
window.$.myAjax = function(a) {
    a.type = a.type || "get", a.headers = a.headers || {}, a.data = a.data || {}, a.success = a.success || function() {}, a.beforeSend = a.beforeSend || function() {}, a.failed = a.failed || function() {}, a.complete = a.complete || function() {}, a.toLogin = a.toLogin || false;
    a.headers.language = 'zh-cn';
    captureTokenFromUrl();
    if (localStorage.getItem('jsessionid')) a.headers.token = localStorage.getItem('jsessionid') || '';
    if (localStorage.getItem('jsessionid')) a.headers.Authorization = localStorage.getItem('jsessionid') || '';
    if (localStorage.getItem('token')) {
        a.headers['X-Custom-Header'] = 'custom-name';
        a.headers.token = localStorage.getItem('token') || '';
    }
    var e = {
        url: a.host ? a.host + a.url : httpPrefix + a.url,
        type: a.type,
        data: a.data,
        async: a.async,
        cache: !1,
        xhrFields: {
            withCredentials: true
        },
        statusCode: {
            601: function(e) {
                if (e.responseJSON && e.responseJSON.href && a.toLogin || e.status === 601 && a.toLogin) {
                    let loginUrl = '/login?service=' + encodeURIComponent(window.location.href);
                    window.location.href = loginUrl;
                }
            }
        },
        crossDomain: true,
        traditional: true,
        headers: a.headers,
        beforeSend: function(request) {
            a.beforeSend(request);
        },
        success: function(e) {
            a.success(e);
        },
        failed: function() {
            a.failed();
        },
        complete: function(e) {
            a.complete(e);
        }
    };
    if (a.contentType) e.contentType = a.contentType;
    a.dataType && (e.dataType = a.dataType), a.xhrFields && (e.xhrFields = a.xhrFields), window.$.ajax(e);
} // var regChn = /^[\u4e00-\u9fa5]+$/,
 // 	zyw = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
 // 	gmreg = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
 // 	specialName = /^[\u4e00-\u9fa5a-zA-Z|\。\，\、\？\《\》\“\‘\—\—\！]*$/,
 // 	regName = /^[\u4e00-\u9fa5A-Za-z0-9]+$/,
 // 	regUrl = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#]])?$/,
 // 	regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
 // 	regphone = /^(1)\d{10}$/,
 // 	regNum = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/;
 // function resetInputFile(e) {
 // 	if (e[0].value) {
 // 		try {
 // 			e[0].value = ""
 // 		} catch(e) {}
 // 		if (e[0].value) {
 // 			var a = document.createElement("form"),
 // 				t = e.nextSibling,
 // 				n = e.parentNode;
 // 			a.appendChild(e),
 // 				a.reset(),
 // 				n.insertBefore(e, t)
 // 		}
 // 	}
 // }
;

//# sourceMappingURL=public.de8e9a2d.js.map
